import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Box, Typography,} from '@mui/material'
import { CustomButton, HumbeeTabs, TextField } from '../../../v2/MUI_custom_component';
import { IDLength, validateIsGSTIN, validateIsPAN } from '../../../utils/settings';
import { useLocation, useNavigate } from 'react-router-dom';
import customToast from '../../../utils/customToast';
import { showApiResponseToast } from '../../../utils/customToast';
import { GstUserGstDataFetch, GstUserPanDataFetch } from '../../../v2/Onboarding/auth/action';
import IconReusable from '../../../components/IconReusable'

const GstPanInput = ({justify = 'center', confirmNavigation}) => {
    const location = useLocation();
    const { show_gst_input, gst_flow, operational_details } = useSelector(state => state.FirmOnboardingReducer);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [currentTab, setCurrentTab] = useState(gst_flow ? 0 : 1);
    const [gstValue, setGstValue] = useState("");
    const [panValue, setPanValue] = useState("");
    const [isValid, setIsValid] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState("");
    const detailPage = location?.state?.detailPage || false;
    const autofillgst = operational_details?.gst_number ? operational_details.gst_number : "";
    const autofillpan = operational_details?.pan_number ? operational_details.pan_number : "";
    useEffect(() => {
        if (detailPage) {
            setGstValue(autofillgst);
            setPanValue(autofillpan);
        }
    }, [autofillgst, autofillpan, detailPage]);
    const tabs = [{ label: "GST", value: "gst" }, { label: "PAN", value: "pan" }];
    const validateGST = (gst) => {
        if (gst.length !== IDLength.GST) return "Please enter a valid GST number (15 characters)";
        return "";
    };
    const validatePAN = (pan) => {
        if (pan.length !== IDLength.PAN) return "Please enter a valid PAN number (10 characters)";
        return "";
    };
    const GetGSTDetails = async (gstNumber) => {
        setIsLoading(true);
        const { error, message, data } = await GstUserGstDataFetch(gstNumber);
        setIsLoading(false);

        const hasGstDetails = Boolean(
            data?.pan ||
            data?.trade_name ||
            data?.legal_name ||
            data?.principal_address
        );

        if (!error && hasGstDetails) {
            const gstDetails = {
                gst_number: gstNumber,
                pan_number: data?.pan || null,
                firm_name: data?.trade_name || data?.legal_name || null,
                address_line_1: data.principal_address?.address_line_1 || null,
                address_line_2: data.principal_address?.address_line_2 + data.principal_address?.address_line_3 || null,
                state_id: data.principal_address?.state_id || null,
                state_name: data.principal_address?.state_name || null,
                pincode_id: data.principal_address?.pincode_id || null,
                district_id: data.principal_address?.district_id || null,
                district_name: data.principal_address?.district_name || null,
                location_id: data.principal_address?.location_id || null,
                location_name: data.principal_address?.location_name || null,
            };
            dispatch({ type: 'SET_GST_DETAILS', payload: gstDetails });
            dispatch({ type: 'SET_OPERATIONAL_DETAILS', payload: gstDetails });
            dispatch({ type: 'SET_GST_NUMBER', payload: gstNumber });
            return {
                success: true,
                message,
                response_meta: data?.response_meta,
            };
        } else if (!error) {
            return {
                success: false,
                message,
                response_meta: data?.response_meta,
            };
        } else {
            customToast.error(message);
            return {
                success: false,
                message,
                response_meta: data?.response_meta,
            };
        }
    };
    const GetPanDetails = async (panNumber) => {
        setIsLoading(true);
        const { error, message, data } = await GstUserPanDataFetch(panNumber);
        setIsLoading(false);

        const hasPanDetails = Boolean(
            data?.name ||
            data?.address_data ||
            data?.state_id ||
            data?.district_id
        );

        if (!error && hasPanDetails) {
            const panDetails = {
                pan_number: panNumber,
                firm_name: data.name || null,
                address_line_1: data.address_data?.line_1 || null,
                address_line_2: data.address_data?.line_2 || null,
                state_id: data.address_data?.state_id || null,
                state_name: data.address_data?.state || null,
                district_id: data.address_data?.district_id || null,
                district_name: data.address_data?.district_name || null,
                location_id: null,
                location_name: null,
                pincode_id: data.address_data?.pincode || null,
            };
            dispatch({ type: 'SET_PAN_DETAILS', payload: panDetails });
            dispatch({ type: 'SET_OPERATIONAL_DETAILS', payload: panDetails });
            return {
                success: true,
                message,
                response_meta: data?.response_meta,
            };
        } else if (!error) {
            return {
                success: false,
                message,
                response_meta: data?.response_meta,
            };
        } else {
            customToast.error(message);
            return {
                success: false,
                message,
                response_meta: data?.response_meta,
            };
        }
    };
    const handleContinue = async () => {
        dispatch({ type: 'RESET_PAN_DETAILS' });
        dispatch({ type: 'RESET_OPERATIONAL_DETAILS' });
        let result = { success: false };
        setError("");
        if (gstValue && !validateIsGSTIN(gstValue)) {
            setError("Invalid GST, please enter a valid GST");
            return;
        }
        if (panValue && !validateIsPAN(panValue)) {
            setError("Invalid PAN, please enter a valid PAN");
            return;
        }
        if (show_gst_input && gstValue) {
            result = await GetGSTDetails(gstValue);
            
        } else {
            const currentTabValue = tabs[currentTab].value;
            if (currentTabValue === "gst" && gstValue) {
                result = await GetGSTDetails(gstValue);
            } else if (currentTabValue === "pan" && panValue) {
                result = await GetPanDetails(panValue);
            }
        }
        if (result?.response_meta) {
            showApiResponseToast(result.response_meta, result.message);
            if (result.response_meta.type !== 'success') {
                return;
            }
        }
        if (result?.success) {
            navigate(confirmNavigation ? confirmNavigation : '/firm-onboarding/confirm-details');
        }
    };
    useEffect(() => {
        autofillgst && setGstValue(autofillgst);
        autofillpan && setPanValue(autofillpan);
    }, []);
    useEffect(() => {
        if (show_gst_input) {
            const gstErr = validateGST(gstValue);
            setIsValid(!gstErr);
        } else {
            const currentTabValue = tabs[currentTab].value;
            if (currentTabValue === "gst") {
                const gstErr = validateGST(gstValue);
                setIsValid(!gstErr);
            } else {
                const panErr = validatePAN(panValue);
                setIsValid(!panErr);
            }
        }
    }, [gstValue, panValue, currentTab, show_gst_input]);
    const handleTabChange = (event, newTab) => {
        setGstValue("");
        setPanValue("");
        setError("");
        dispatch({ type: 'SET_GST_FLOW', payload: newTab === 1 ? false : true });
        setCurrentTab(newTab);
    };
    if (show_gst_input) {
        return (
            <Box sx={{ display: "flex", flexDirection: "column", height: { md: '100vh' }, alignItems: { md: 'center' }, justifyContent: { md: justify } }}>
                <Box sx={{ display: "flex", flexDirection: "column", gap: 4, width: '100%' }}>
                    
                    <Box sx={{ display: "flex", flexDirection: "column", gap: 2, }}>
                        <Box>
                            <TextField
                                label="GST*"
                                placeholder="Enter GST number"
                                value={gstValue}
                                onChange={(e) => { setError(""); setGstValue(e.target.value.toUpperCase()) }}
                                inputProps={{ maxLength: IDLength.GST, minLength: IDLength.GST }}
                                fullWidth
                                disabled={isLoading}
                                error={!!error}
                            />
                            {error && (
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                                    <IconReusable name="ErrorFilled" size={20} color="#CC0000" />
                                    <Typography variant='body1' sx={{ color: '#CC0000', }}>
                                        {error}
                                    </Typography>
                                </Box>
                            )}
                        </Box>
                        <Typography variant='body1'>
                            *GST is required to purchase & sell products on HUMBEE
                        </Typography>
                    </Box>
                    <CustomButton
                        label="Continue"
                        variant="filled"
                        fullWidth
                        disabled={!isValid || isLoading}
                        onClick={handleContinue}
                        loading={isLoading}
                    />
                </Box>
            </Box>
        )
    }
    
    return (
        <Box sx={{ display: "flex", flexDirection: "column", gap: 4 }}>
            <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                <HumbeeTabs
                    tabsSx={{ width: 'fit-content' }}
                    tabVariant="small"
                    tabType="outlined"
                    data={tabs}
                    currentTab={currentTab}
                    onChange={handleTabChange}
                    getTabLabel={item => item.label}
                    renderTabContent={(item) => {
                        if (item.value === "gst") {
                            return (
                                <Box>
                                    <TextField
                                        label="GST*"
                                        placeholder="Enter GST number"
                                        value={gstValue}
                                        onChange={(e) => {setError(""); setGstValue(e.target.value.toUpperCase())}}
                                        inputProps={{ maxLength: IDLength.GST, minLength: IDLength.GST }}
                                        fullWidth
                                        disabled={isLoading}
                                        error={currentTab === 0 && !!error}
                                    />
                                    {error && (
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                                            <IconReusable name="ErrorFilled" size={20} color="#CC0000" />
                                            <Typography variant='body1' sx={{ color: '#CC0000', }}>
                                                {error}
                                            </Typography>
                                        </Box>
                                    )}
                                </Box>
                            );
                        }
                        if (item.value === "pan") {
                            return (
                                <Box>
                                    <TextField
                                        label="PAN*"
                                        placeholder="Enter PAN number"
                                        value={panValue}
                                        onChange={(e) => {setError(""); setPanValue(e.target.value.toUpperCase())}}
                                        inputProps={{ maxLength: IDLength.PAN, minLength: IDLength.PAN }}
                                        fullWidth
                                        disabled={isLoading}
                                        error={currentTab === 1 && !!error}
                                    />
                                    {error && (
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                                            <IconReusable name="ErrorFilled" size={20} color="#CC0000" />
                                            <Typography variant='body1' sx={{ color: '#CC0000', }}>
                                                {error}
                                            </Typography>
                                        </Box>
                                    )}
                                </Box>
                            );
                        }
                        return null;
                    }}
                />
                <Typography variant='body1'>
                    *GST/PAN is required to purchase & sell products on HUMBEE
                </Typography>
            </Box>
            <CustomButton
                label="Continue"
                variant="filled"
                fullWidth
                disabled={!isValid || isLoading}
                onClick={handleContinue}
                loading={isLoading}
            />
        </Box>

    );
}

export default GstPanInput